import React, { useEffect, useState } from 'react'


const Messages = ({ data }) => {
    const [verticalOffset, setVerticalOffset] = useState(0);
    const [flowState, setFlowState] = useState('idle'); // idle, entering, typing, visible, fadingOut
    const [messageData, setMessageData] = useState(null);
    const [pendingData, setPendingData] = useState(null);
    const [displayedText, setDisplayedText] = useState('');

    // 1. Recepción y encolamiento de datos
    useEffect(() => {
        // Si no hay datos, no hacemos nada
        if (!data) return;

        // A. Configuración (Posición)
        if (data.type === 'config' && data.offsetY !== undefined) {
            setVerticalOffset(data.offsetY);
            return;
        }

        // B. Comando de Ocultar / Quitar
        // Si mandan a limpiar o llega tu payload de quitar (ej. {type: "messages", data: {idTile: 20}})
        if (!data.message) {
            setFlowState(prevFlow => {
                if (prevFlow !== 'idle' && prevFlow !== 'fadingOut') return 'fadingOut';
                return prevFlow;
            });
            setPendingData(null);
            return;
        }

        // C. Comando de Mostrar Mensaje Nuevo
        // Usamos prevFlow para evitar meter flowState en el arreglo de dependencias
        setFlowState(prevFlow => {
            if (prevFlow === 'idle') {
                setMessageData(data);
                return 'entering'; // Entra directo
            } else {
                setPendingData(data); // Lo formamos en la fila
                return prevFlow !== 'fadingOut' ? 'fadingOut' : prevFlow; // Obligamos a salir al actual
            }
        });

    }, [data]); // <-- ¡CLAVE! Solo dependemos de 'data'. Adiós al bucle infinito.

    // 2. Control de transiciones (Entrada y Salida)
    useEffect(() => {
        let timeout;
        if (flowState === 'entering') {
            // El tiempo debe coincidir con la duración de la animación CSS de entrada
            timeout = setTimeout(() => setFlowState('typing'), 500); // <--- Efecto de entrada y salida. Coincide con 0.5s de SASS. Cambiar SASS si es que se cambia este valor.
        } else if (flowState === 'fadingOut') {
            // El tiempo debe coincidir con la duración de la animación CSS de salida
            timeout = setTimeout(() => {
                if (pendingData) {
                    setMessageData(pendingData);
                    setPendingData(null);
                    setFlowState('entering');
                } else {
                    setMessageData(null);
                    setFlowState('idle');
                }
                setDisplayedText('');
            }, 500); // <--- Efecto de entrada y salida. Coincide con 0.5s de SASS. Cambiar SASS si es que se cambia este valor.
        }
        return () => clearTimeout(timeout);
    }, [flowState, pendingData]);

    // 3. Efecto Máquina de Escribir
    useEffect(() => {
        if (flowState === 'typing' && messageData) {
            let currentIndex = 0;
            const fullText = messageData.message;
            setDisplayedText('');
            
            const interval = setInterval(() => {
                setDisplayedText(fullText.substring(0, currentIndex + 1));
                currentIndex++;
                
                if (currentIndex >= fullText.length) {
                    clearInterval(interval);
                    setFlowState('visible');
                }
            }, 35); // Velocidad de la máquina de escribir (ms por letra)
            // Menor = más rápido (ej. 20). Mayor = más lento (ej. 60).
            
            return () => clearInterval(interval);
        }
    }, [flowState, messageData]);

    if (flowState === 'idle') return null;

    return (
        <div className="messages" style={{ bottom: `${verticalOffset}px` }}>
            <div className={`messages__banner messages__banner--${flowState}`}>
                <img className="messages__logo messages__logo--left" src="/img/overlays/messages/logo-capitanes.png" alt="Logo Izquierdo" />
                
                <div className="messages__content">
                    {messageData?.sender && (
                        <div className="messages__sender">De: {messageData.sender}</div>
                    )}
                    <div className="messages__text">{displayedText}</div>
                </div>

                <img className="messages__logo messages__logo--right" src="/img/overlays/messages/logo-interaktia-blanco.png" alt="Logo Derecho" />
                {/* <img className="messages__logo messages__logo--right" src="/img/overlays/messages/somos-perrisimas.png" alt="Logo Derecho" /> */}
            </div>
        </div>
    );
};

export { Messages };